import * as Scrivito from "scrivito";
import { isLiv } from "^/utils/isLiv";
import LanguageSwitch from "./LanguageSwitch";
import SearchButton from "./SearchButton";
import getHomepage from "../../utils/getHomepage";
import EasyLanguageButton from "../EasyLanguageButton";
import SignLanguageButton from "../SignLanguageButton";

function Options({ currentPage }) {
  const homepage = getHomepage(currentPage);
  if (!homepage) {
    return null;
  }
  const lang = homepage.language();
  const easyLanguagePageLink = homepage.get("easyLanguagePage");
  const signLanguagePageLink = homepage.get("signLanguagePage");
  const searchResultsPage = homepage.get("searchPage");

  return (
    <div id="top-navigation">
      <div className="container navigation" />
      <div id="options-navigation" className="d-flex pt-2 justify-content-end">
        <EasyLanguageButton
          lang={lang}
          easyLanguagePageLink={easyLanguagePageLink}
        />
        <SignLanguageButton
          lang={lang}
          signLanguagePageLink={signLanguagePageLink}
        />
        {!isLiv(currentPage) && (
          <SearchButton searchResultsPage={searchResultsPage} />
        )}
        <LanguageSwitch />
      </div>
    </div>
  );
}

export default Scrivito.connect(Options);
